import { JobCard } from '@/modules/jobs/components/JobCard';
import type { JobApi } from '@/modules/jobs/types';

interface JobListProps {
  jobs: JobApi[];
}

export const JobList = ({ jobs }: JobListProps) => {
  return (
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-2 2xl:grid-cols-3">
      {jobs.map((job) => (
        <JobCard key={job.id} job={job} showCompanyClientStatus />
      ))}
    </div>
  );
};
